import moment from 'moment';
import React from 'react'

function formatAmount(value) {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  const amount = Number(value)
  const text = new Intl.NumberFormat('vn-VI', {}).format(Math.abs(amount))
  if (amount > 0) {
    return `+${text}`
  }
  if (amount < 0) {
    return `-${text}`
  }
  return text
}

export const TableRow = (props) => {
  const { createdAt, kind, amount, sourceId, description } = props
  const numeric = Number(amount)
  const amountClass = numeric < 0 ? 'text-danger' : 'text-success'

  return (
    <tr>
      <td className="text-center">{createdAt ? moment(createdAt).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
      <td>{kind}</td>
      <td className={`text-end fw-900 ${amountClass}`}>{formatAmount(amount)}</td>
      <td className="text-break">{sourceId}</td>
      <td className="text-break small">{description}</td>
    </tr>
  );
};
